import { observable, computed, action } from 'mobx';

export default class NotificationsStore {
  @observable notifications = [];

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action('Clear notifications')
  clearNotifications() {
    this.notifications.clear();
  }

  @action('Clear notification')
  clearNotification(notification) {
    this.notifications.remove(notification);
  }

  @action('Clear most recent notification')
  clearMostRecentNotification() {
    if (!this.notifications.length) {
      return;
    }

    this.clearNotification(this.notifications[this.notifications.length - 1]);
  }

  @action('Clear oldest notification')
  clearOldestNotification() {
    if (!this.notifications.length) {
      return;
    }

    this.clearNotification(this.notifications[0]);
  }

  @action('Add notification')
  pushNotification(notification) {
    this.notifications.push(notification);
  }

  @action('Pop notification')
  popNotification() {
    return this.notifications.pop();
  }

  @computed
  get errors() {
    return this.notifications.filter(
      notification => notification.type === 'error'
    );
  }

  @computed
  get warnings() {
    return this.notifications.filter(
      notification => notification.type === 'warning'
    );
  }

  @computed
  get infos() {
    return this.notifications.filter(
      notification => notification.type === 'info'
    );
  }

  @computed
  get logs() {
    return this.notifications.filter(
      notification => notification.type === 'log'
    );
  }
}



// WEBPACK FOOTER //
// ./src/stores/NotificationsStore.js